export const isScheduleParticipantCancelable = (payStatusNumber) => Number(payStatusNumber) === 1;

export const buildScheduleParticipantCancelPayload = (item) => ({
    payId: item.pay_id,
    userId: item.id,
});
